import React from "react"
import { graphql } from "gatsby"
import NewRelic from "@vp/react-new-relic-browser"
import { GridContainer, Row } from "@vp/swan"
import Layout from "../components/layout.js"
import ErrorPage from "../components/error-page.js"
import Analytics from "../components/analytics.js"
import "../styles/error-page.scss"

const Page = props => {
  return (
    <>
      <Analytics
        locale={props.pageContext.node_locale}
        pageName={props.pageContext.pageName}
        pageSection={props.pageContext.pageSection}
        trackingConfig={props.data.trackingConfig}
      />
      <NewRelic
        newRelicApplicationId={process.env.GATSBY_NEW_RELIC_APPLICATION_ID}
      />
      <Layout
        locale={props.pageContext.node_locale}
        title={props.data.errorPage.title}
        pageContext={props.pageContext}
        visageDomain={props.pageContext.visageDomain}
        trackingData={{
          pageName: props.pageContext.pageName,
          pageSection: props.pageContext.pageSection,
        }}
      >
        <GridContainer>
          <Row>
            <div className="error-page-panel">
              <ErrorPage
                headline={props.data.errorPage.headline}
                subcopy={props.data.errorPage.subcopy}
                cta={props.data.errorPage.cta}
                searchText={props.data.errorPage.searchText}
                errorImage={props.pageContext.logo}
                help={props.data.errorPage.help}
                homeUrl={props.pageContext.home_url}
                locale={props.pageContext.node_locale}
                title={props.data.errorPage.title}
                tenant={props.pageContext.tenant}
                trackingData={{
                  pageName: props.pageContext.pageName,
                  pageSection: props.pageContext.pageName,
                }}
              />
            </div>
          </Row>
        </GridContainer>
      </Layout>
    </>
)}

export const pageQuery = graphql`
  query($node_locale: String!, $tenant: String!, $pageId: String!) {
    trackingConfig(culture: $node_locale, tenant: $tenant)
    errorPage(node_locale: {eq: $node_locale}, pageId: {eq: $pageId}) {
      headline {
        text
      }
      subcopy {
        text
      }
      cta {
        text
      }
      title {
        text
      }
      searchText {
        text
      }
      help {
        text
      }
    }
  }
`

export const validateData = ({ issuesRegistry }) => {
  issuesRegistry.registerContextIssueIfEmpty(
    ["tenant", "home_url", "node_locale"],
    { group: "critical", isDeveloper: true }
  )

  issuesRegistry.registerDataIssueIfEmpty([
    "errorPage.headline",
    "errorPage.subcopy",
    "errorPage.cta",
    "errorPage.searchText",
    "errorPage.title",
    "errorPage.helpText",
  ])
}

export default Page

export { Head } from "../components/head.js"
